define('views/content/cd_roles',['require','views/base/list_page_view','views/components/cd_role/cd_roles','collections/cd_roles','text!templates/content/cd_roles.html'],function(request){

    var BaseListPageView = require('views/base/list_page_view');

    var RoleView = require('views/components/cd_role/cd_roles');
    var CDRolesCollection = require('collections/cd_roles');

    var temp = require("text!templates/content/cd_roles.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'cd-roles-page',
        titleKey: 'personal_roles',

        setCollection: function () {
            this.collection = new CDRolesCollection();
        },

        onRender: function() {
            this.ListContainer.show(new RoleView({
                collection: this.collection
            }));
        }

    });
});
